import { enabledForEventType } from 'app/shared/utils/events';
import { enabledForEventOrganizedAs } from 'app/shared/utils/events';
import { useVisaAuth } from 'app/shared/utils/visa';
import { Event } from 'app/shared/typings';

export const useVisaPromo = ({ event }: { event: Event }) => {
  const {
    visaPreSaleEligible: userIsVisaEligible,
    canBypassVisaValidation,
    visaFreeTicketsRemaining,
    visaFreeTicketRedeemedForEvent,
    cardType,
  } = useVisaAuth({
    eventId: Number(event.id),
    skipLoadCardRedemptionsStatus: false,
  });

  const isDiscoveryEvent = enabledForEventType(event.type, 'visaPresale');
  const isVisaPresaleEnabledForEventOrganizedAs = enabledForEventOrganizedAs(
    event.eventOrganizedAs,
    'visaPresale'
  );
  const eventIsVisaEligible =
    isDiscoveryEvent && isVisaPresaleEnabledForEventOrganizedAs;

  const canRedeemVisaFreeTicket =
    eventIsVisaEligible &&
    userIsVisaEligible &&
    visaFreeTicketsRemaining > 0 &&
    !visaFreeTicketRedeemedForEvent;

  return {
    eventIsVisaEligible,
    userIsVisaEligible,
    canBypassVisaValidation,
    canRedeemVisaFreeTicket,
    visaFreeTicketRedeemedForEvent,
    cardType,
  };
};
